import AlertDialog from '@/components/atom/AlertDialog';
import useBlockDialogStore from '@/src/store/useBlockDialogStore';

const globalBlockDialogText = {
  push: {
    title: '페이지 이동하기',
    message: '변경사항은 저장되지 않습니다. 그래도 이동하시겠습니까?',
  },
  pop: {
    title: 'test2',
    message: 'test2',
  },
} as const;

function GlobalBlockDialog() {
  const { isOpen, setClose, type, onOk, onCancel } = useBlockDialogStore();

  return (
    <AlertDialog
      open={isOpen}
      onOpenChange={setClose}
      onOk={onOk}
      onCancel={onCancel}
      title={globalBlockDialogText[type].title}
    >
      {globalBlockDialogText[type].message}
    </AlertDialog>
  );
}

export default GlobalBlockDialog;
